// src/components/admin/UserDetails.jsx
import React from 'react';

const UserDetails = ({ user, onClose }) => {
  if (!user) return null;

  // Helper to get readable role name
  const getRoleName = (role) => {
    switch (role) {
      case 'superadmin': return 'SuperAdmin';
      case 'admin': return 'Provider';
      case 'simpleuser': return 'Analyste';
      default: return role;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold text-gray-900">Détails de l'utilisateur</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 text-2xl font-bold"
            >
              ×
            </button>
          </div>
          
          <div className="space-y-4">
            <div className="border-b border-gray-200 pb-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Informations générales</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Nom</p>
                  <p className="font-medium">{user.name || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Email</p>
                  <p className="font-medium">{user.email || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Rôle</p>
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    user.role === 'superadmin'
                      ? 'bg-purple-100 text-purple-800'
                      : user.role === 'admin'
                      ? 'bg-blue-100 text-blue-800'
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {getRoleName(user.role)}
                  </span>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Statut</p>
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    user.status === 'active'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {user.status === 'active' ? 'Actif' : 'Inactif'}
                  </span>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Entreprise</p>
                  <p className="font-medium">{user.companyName || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Dernière connexion</p>
                  <p className="font-medium">
                    {user.lastLogin 
                      ? new Date(user.lastLogin).toLocaleString()
                      : 'Jamais'}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="border-b border-gray-200 pb-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Statistiques</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-blue-50 p-3 rounded-lg">
                  <p className="text-sm text-gray-600">Analyses créées</p>
                  <p className="text-xl font-bold text-blue-700">{user.analysesCreated || 0}</p>
                </div>
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="text-sm text-gray-600">Rapports générés</p>
                  <p className="text-xl font-bold text-green-700">{user.reportsGenerated || 0}</p>
                </div>
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="text-sm text-gray-600">Activités récentes</p>
                  <p className="text-xl font-bold text-purple-700">{user.recentActivities || 0}</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Actions rapides</h3>
              <div className="flex flex-wrap gap-2">
                <button
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                  onClick={() => {
                    // This would typically open a modal or navigate to edit user
                    console.log('Edit user', user);
                  }}
                >
                  Modifier l'utilisateur
                </button>
                <a
                  href={`/admin/users/${user._id}/logs`}
                  className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 text-sm"
                >
                  Voir les logs
                </a>
                <a
                  href={`/admin/users/${user._id}/analyses`}
                  className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm"
                >
                  Voir les analyses
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;